module.exports = "//static.hsappstatic.net/AdsUI/static-1.38297/imgs/success_check_wavy.svg"